import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import Caption from '../Typography/Caption'
import TextInputOnly from 'components/Common/Form/Input/TextInputOnly'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FormatCurrency from 'components/Common/FormatCurrency'
import Slider from './Slider'

const Container = styled(VerticalSpacer)`
  position: relative;
  width: 100%;
`

interface Props extends React.ComponentProps<typeof Slider> {
  variant: 'label' | 'input';
  format?: 'currency' | 'none';
}

function SliderInput(props: Props) {
  const { variant, format = 'none', ...sliderProps } = props
  const [value, setValue] = useState<number>(sliderProps.defaultValue ?? sliderProps.value ?? sliderProps.min)

  const onSliderChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    sliderProps.onChange?.(e)
    setValue(e.currentTarget.valueAsNumber)
    // eslint-disable-next-line
  }, [sliderProps.onChange])

  return (
    <Container gap={variant === 'label' ? 4 : 16}>
      <Slider
        {...sliderProps}
        onChange={onSliderChange}
      />
      {variant === 'label' &&
        <Caption variant="large" colour="neutral-three" align="end">
          {format === 'currency' && <FormatCurrency value={value} />}
          {format === 'none' && <>{value}</>}
        </Caption>}
      {variant === 'input' && <TextInputOnly value={value} noValidationSpacing />}
    </Container>
  )
}

export default SliderInput
